import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  staging: true,
  development: false,
  apiUrl: 'https://stage-api.insightstobehavior.net/api',
  lmsUrl: 'https://stage-moodle.insightstobehavior.net',
  label: 'STAGE',
  notificatioHubUrl: 'https://stage-api.insightstobehavior.net/notificationHub',
  secretKey: '725a0e9c-1286-411d-b598-5943a6308f0f',
};
